import React from 'react'
import PropTypes from 'prop-types'

import AttachmentsList from 'components/AttachmentsList'

import styles from './styles'

const AdditionalQuestionAnswer = (props) => {
  const { questionData } = props
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Pergunta adicional</h2>
      <div className={classes.answerWrapper}>
        <p className={classes.questionText}>
          <span>Assunto: </span>
          {questionData?.subject}
        </p>
        <p className={classes.questionText}>
          <span>Pergunta: </span>
          {questionData?.text}
        </p>
        {questionData?.answer?.answer_object?.text ? (
          <p className={classes.questionText}>
            <span>Resposta: </span>
            {questionData?.answer?.answer_object?.text}
          </p>
        ) : null}
        {questionData?.answer?.answer_object?.attachments?.length > 0 ? (
          <AttachmentsList
            attachments={questionData?.answer?.answer_object?.attachments}
          />
        ) : null}
      </div>
    </div>
  )
}

AdditionalQuestionAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string,
    text: PropTypes.string,
    subject: PropTypes.string,
    answer: PropTypes.shape({
      uuid: PropTypes.string,
      answer_object: PropTypes.shape({
        text: PropTypes.string,
        attachments: PropTypes.array,
      }),
    }),
  }).isRequired,
}

export default AdditionalQuestionAnswer
